import { useState } from 'react';
import FeedLayout from '../components/layout/FeedLayout';
import StoriesBar from '../components/feed/StoriesBar';
import FeedPost from '../components/feed/FeedPost';
import RightSidebar from '../components/feed/RightSidebar';
import { mockStories, mockPosts, mockSuggestedUsers } from '../data/mockFeedData';

function Feed() {
  const [stories] = useState(mockStories);
  const [posts] = useState(mockPosts);
  const [suggestedUsers] = useState(mockSuggestedUsers);

  return (
    <FeedLayout>
      <div className="min-h-screen">
        <div className="max-w-feed-lg mx-auto flex justify-center pt-8 px-4">
          {/* Main feed column */}
          <main className="w-full max-w-feed">
            {/* Stories bar */}
            <StoriesBar stories={stories} />

            {/* Feed posts */}
            {posts.map((post) => (
              <FeedPost key={post.id} post={post} />
            ))}

            {/* End of feed message */}
            <div className="text-center py-8 text-puzzle-text-secondary">
              <p className="text-sm">You&apos;re all caught up!</p>
              <p className="text-xs mt-1">Check back later for more puzzles</p>
            </div>
          </main>

          {/* Right sidebar (desktop only) */}
          <RightSidebar suggestedUsers={suggestedUsers} />
        </div>
      </div>
    </FeedLayout>
  );
}

export default Feed;
